// extracted by mini-css-extract-plugin
module.exports = {"Header":"styles_Header__iPPLD","scrolled":"styles_scrolled__s1BB6","toggle":"styles_toggle__u6LzT","height":"styles_height__QK1WS"};